/** @format */

import React, { useState } from "react";

import { Link, withRouter } from "react-router-dom";
import "./floating.css";
import Icon from "../../assets/floating-icon.ico";
import DarkModeSwitch from "../navbar/DarkModeSwitch";
import { TOGGLE_GENRE } from "../../stateManagement/variables";
import { UiContext } from "../../stateManagement/context/UiContext";

const FloatingMenu = () => {
  const { dispatch } = React.useContext(UiContext);
  const [active, setActive] = useState();

  
  return (
    <>
      <div
        className="floating z-50 bg-gray-50 dark:bg-gray-700  dark:text-white shadow-md p-3 "
        onClick={() => setActive(!active)}
      >
        <span>
          <img src={Icon} alt="Menu" />
        </span>
        <ul
          className={
            active === true
              ? "float-list-active dark:bg-dark-800 dark:shadow-md bg-gray-50 shadow-md  dark:text-white "
              : "float-list dark:text-white"
          }
        >
          <li
            onClick={() => dispatch({ type: TOGGLE_GENRE })}
            className="dark:text-white"
          >
            <i className="fa  mt-2 fas fa-film  fa-lg" />
            <p>Genres</p>
          </li>
          <li className="dark:text-white">
            <i className="fa  mt-1 fa-search  fa-lg" />{" "}
            <Link to="/search">
              <p>Search</p>
            </Link>
          </li>
          <li className="dark:text-white">
            <i className="fas mt-1 fa-bookmark fa-lg" />
            <Link to="/bookmarks">
              <p>Bookmarks</p>
            </Link>
          </li>

          <li className="dark:text-white">
            <i className="fas mt-1 fa-phone fa-lg"></i>
            <a href="mailto:trendinganimeofficial@gmail.com?subject=Trending Anime ">
              <p>Contact-Us</p>
            </a>
          </li>

          <li>
            <div className="w-16  m-auto">
              <DarkModeSwitch />
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};

export default withRouter(FloatingMenu);
